import moment from 'moment'

export const short = (dateTime) => {
  return moment(dateTime).format('YYYY-MM-DD HH:mm')
}

export const standard = (dateTime) => {
  return moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
}

export const friendly = (dateTime) => {
  return moment(dateTime).format('DD MMM, YYYY HH:mma')
}

export const date = (dateTime) => {
  return moment(dateTime).format('DD MMM, YYYY')
}

export const dateShort = (dateTime) => {
  return moment(dateTime).format('YYYY-MM-DD')
}

export const monthShort = (dateTime) => {
  return moment(dateTime).format('YYYY-MM')
}

export const dateFriendly = (dateTime) => {
  return moment(dateTime).format('DD MMM')
}

export const time = (dateTime) => {
  return moment(dateTime).format('HH:mm:ss')
}

export const timeShort = (dateTime) => {
  return moment(dateTime).format('HH:mm')
}

export const timeFriendly = (dateTime) => {
  return moment(dateTime).format('HH:mma')
}

export const now = () => {
  return moment()
}

export const nowUtc = () => {
  return moment.utc()
}

const daysOfWeekSorter = (a, b) => {
  const order = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
  if (a === 'monday') return -1 // 'monday' comes first
  if (b === 'monday') return 1 // 'monday' comes first

  if (a === 'sunday') return 1 // 'sunday' comes last
  if (b === 'sunday') return -1 // 'sunday' comes last

  return order.indexOf(a) - order.indexOf(b)
}

export const daysOfWeek = () => {
  return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
}

export const sortDaysOfWeek = (daysOfWeek) => {
  return daysOfWeek.sort(daysOfWeekSorter)
}

export const daysOfMonth = (limit = 31) => {
  let results = []
  for (let i = 1; i <= limit; i++) {
    results.push(i)
  }
  return results
}

export const dayOfMonthSuffix = (day) => {
  const suffixes = ["'th", "'st", "'nd", "'rd"]
  const numMod100 = day % 100
  const suffix = suffixes[(numMod100 - 20) % 10] || suffixes[numMod100] || suffixes[0]
  return `${day}${suffix}`
}

export const daysOfMonthSuffix = (dayNumbers) => {
  let results = []
  dayNumbers.forEach(day => {
    results.push(dayOfMonthSuffix(day))
  })
  return results
}

export const trimSeconds = (timeString) => {
  return timeString.slice(0, 5)
}

export const appendSeconds = (timeString, seconds = '00') => {
  return timeString.length === 5 ? timeString + ':' + seconds : timeString
}

export default {
  short,
  standard,
  friendly,
  date,
  dateShort,
  dateFriendly,
  time,
  timeShort,
  timeFriendly,
  now,
  nowUtc,
  daysOfWeek,
  sortDaysOfWeek,
  daysOfMonth,
  dayOfMonthSuffix,
  daysOfMonthSuffix,
  trimSeconds,
  appendSeconds
}



// WEBPACK FOOTER //
// ./src/common/dateUtils.js